import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { User } from '../../../redux/vmsApi';

const RenderApproverName: React.FC<{ user: User }> = ({ user }) => {
  const { name, jobTitle, roles } = user;

  const displayText = jobTitle ? `${name}, ${jobTitle}` : name;

  const tooltipTitle = roles && roles.length > 0 ? roles.join(', ') : 'No Roles';

  return (
    <Tooltip title={tooltipTitle} arrow>
      <span style={{ cursor: 'default' }}>
        {displayText}
      </span>
    </Tooltip>
  );
};

export default RenderApproverName;